
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.134 8.564c-.778 0-1.504.311-1.867.947-.376-.636-1.038-.947-1.881-.947C1.063 8.564 0 9.458 0 11.079v3.799c0 .299.221.532.518.532a.523.523 0 00.519-.532v-3.812c0-1.024.597-1.543 1.348-1.543.764 0 1.361.519 1.361 1.543v3.812c0 .298.221.532.52.532a.523.523 0 00.518-.532v-3.812c0-1.024.597-1.543 1.348-1.543.766 0 1.362.519 1.362 1.543v3.812c0 .298.22.532.518.532a.523.523 0 00.518-.532v-3.799c0-1.621-1.063-2.516-2.399-2.516zM16.292 8.59a.52.52 0 00-.518.518v.493a3.323 3.323 0 00-2.424-1.037c-1.907 0-3.359 1.517-3.359 3.436s1.452 3.436 3.359 3.436c.972 0 1.815-.389 2.424-1.037v.479c0 .298.233.532.518.532a.515.515 0 00.519-.532v-5.77a.512.512 0 00-.519-.518zm-.518 3.514c-.052 1.349-1.076 2.373-2.36 2.373-1.323 0-2.374-1.076-2.374-2.477s1.051-2.477 2.374-2.477c1.284 0 2.308 1.025 2.36 2.373v.207zM23.87 14.554l-2.178-2.581L23.87 9.38a.48.48 0 00-.376-.791c-.156 0-.26.064-.363.181l-2.062 2.451-2.062-2.451a.503.503 0 00-.389-.181.531.531 0 00-.532.518c0 .104.053.233.13.337l2.166 2.581-2.166 2.581a.53.53 0 00-.116.324c0 .272.221.479.492.479.156 0 .26-.064.363-.181l2.062-2.451 2.062 2.438c.091.13.246.194.389.194.272 0 .532-.233.532-.518a.543.543 0 00-.13-.337z"}})])
          )
        }
      }
    